import { z } from 'zod'
import { asObjectType } from '@gqloom/zod'

import { documentFileConfigFieldSchema } from '../file-upload/document.schemas'

export const clientFileSchema = z
  .object({
    fileId: z.string().uuid(),
    clientId: z.string().uuid(),
    siteId: z.string().uuid(),
    fileName: z.string(),
    fileType: z.string(),
    url: z.string(),
    createdAt: z.coerce.date().nullable().optional(),
    uploadedAt: z.coerce.date(),
    fileJSON: documentFileConfigFieldSchema,
  })
  .register(asObjectType, {
    name: 'ClientFile',
  })

export const createClientFileInputSchema = z
  .object({
    fileName: z.string(),
    format: z.string(),
  })
  .register(asObjectType, {
    name: 'CreateClientFileInput',
  })

export const clientFileUrlSchema = z
  .object({
    url: z.string(),
  })
  .register(asObjectType, {
    name: 'ClientFileUrl',
  })

export const deleteClientFileResponseSchema = z
  .object({
    success: z.boolean(),
  })
  .register(asObjectType, {
    name: 'DeleteClientFileResponse',
  })

export const updateClientFileNameResponseSchema = z
  .object({
    success: z.boolean(),
    message: z.string().optional(),
  })
  .register(asObjectType, {
    name: 'UpdateClientFileNameResponse',
  })

export const clientFilesListSchema = z.array(clientFileSchema).register(asObjectType, {
  name: 'ClientFilesList',
})

export type ClientFileSchema = z.infer<typeof clientFileSchema>
export type CreateClientFileInputSchema = z.infer<typeof createClientFileInputSchema>
export type ClientFileUrlSchema = z.infer<typeof clientFileUrlSchema>
export type DeleteClientFileResponseSchema = z.infer<typeof deleteClientFileResponseSchema>
export type UpdateClientFileNameResponseSchema = z.infer<typeof updateClientFileNameResponseSchema>
export type ClientFilesListSchema = z.infer<typeof clientFilesListSchema>
